import {LazyLoadingData} from './lazy-loading-data';
import {DetailLabel} from './detail-label';
import {PaginationModel} from '../screens/models/Onlinekeys-search.model';

export class DetailPanel {
  name;
  layout;
  subPanels: DetailPanel[];
  errorText: string;
  nameAndValues: Map<string, DetailLabel>;
  lazyLoadingData: LazyLoadingData;
  paginationObj: PaginationModel;
  lazyLoaded: boolean;
  hasTable: boolean;
  transactionsDetailsBankCode?: string;
  expanded: boolean;

  constructor(name: any, transactionsDetailsBankCode?: string) {
    this.name = name;
    this.subPanels = [];
    this.nameAndValues = new Map();
    this.transactionsDetailsBankCode = transactionsDetailsBankCode;
  }

  public getName() {
    return this.name;
  }

  public isLazyLoaded(value: boolean) {
    this.lazyLoaded = value;
  }

}
